export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5663.9ce2ffc4.jpg";